import { render, staticRenderFns } from "./lot-unit-edit-form.html?vue&type=template&id=16966c1d&scoped=true&"
import script from "./lot-unit-edit-form.js?vue&type=script&lang=js&"
export * from "./lot-unit-edit-form.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16966c1d",
  null
  
)

export default component.exports